import React, { FunctionComponent } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Icon, Popup } from 'semantic-ui-react';
import { ToastSuccess } from 'utils';
import { Review } from '../types/review.type';
import { getReviewSiteUrl } from '../utils/getReviewSiteUrl';

type CopyReviewLinkButtonProps = {
  review: Review;
  proViewId?: number;
};

export const CopyReviewLinkButton: FunctionComponent<
  CopyReviewLinkButtonProps
> = ({ review, proViewId }) => (
  <Popup
    content="Copier le lien vers l'avis"
    position="top center"
    trigger={
      <CopyToClipboard text={getReviewSiteUrl(review, proViewId)}>
        <Button
          basic
          color="grey"
          icon
          onClick={(): void => {
            ToastSuccess('Succès', 'Lien copié !');
          }}
        >
          <Icon name="linkify" />
        </Button>
      </CopyToClipboard>
    }
  />
);
